import { BsThreeDots } from 'react-icons/bs';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import Swal from 'sweetalert2';
import moment from 'moment';
import InvoiceNumberComponent from '../Format';
const ProposalList = (props) => {
  props.setShow(true);
  const user = props.user;
  const userToken = localStorage.getItem("userToken");
  const navigate = useNavigate();

  const initialFilters = {
    filter: "",
    asc: "no",
    fromDate: "",
    toDate: ""
  };

  const [filters, setFilters] = useState(initialFilters);
  const [activeFilters, setActiveFilters] = useState(initialFilters);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [proposals, setProposals] = useState([]);
  const [pagination, setPagination] = useState({ total: 0, totalPages: 1 });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = (invoiceId) => {
    const config = {
      method: 'delete',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_HOST}proposal/${invoiceId}`,
      headers: {
        'Authorization': `Bearer ${userToken}`
      }
    };

    axios.request(config)
      .then((response) => {
        if (response.data.status) {
          Swal.fire({
            icon: "success",
            title: "Proposal Deleted Successfully",
            showConfirmButton: false,
            timer: 1500,
          });
          fetchProposals();
        }

      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "warning",
          title: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
      });
  };

  const fetchProposals = useCallback(async () => {
    if (!userToken) {
      setError("Authentication required.");
      setProposals([]);
      setPagination({ total: 0, totalPages: 1 });
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_HOST}filterproposals`,
        {
          headers: {
            'Authorization': `Bearer ${userToken}`
          },
          params: {
            filter: activeFilters.filter,
            asc: activeFilters.asc,
            fromDate: activeFilters.fromDate,
            toDate: activeFilters.toDate,
            page,
            limit
          }
        }
      );

      const fetchedProposals = response.data?.proposals ?? [];
      const paginationMeta = response.data?.pagination ?? {};

      const totalPages = Math.max(paginationMeta.totalPages || 1, 1);
      const total = paginationMeta.total ?? fetchedProposals.length;

      if (page > totalPages && totalPages > 0) {
        setPage(totalPages);
        setPagination({
          total,
          totalPages
        });
        return;
      }

      setProposals(fetchedProposals);
      setPagination({
        total,
        totalPages
      });
    } catch (error) {
      console.error("Error fetching proposals:", error);
      setError("Unable to fetch proposals. Please try again.");
      setProposals([]);
      setPagination({ total: 0, totalPages: 1 });
    } finally {
      setIsLoading(false);
    }
  }, [activeFilters, limit, page, userToken]);

  const handleSendToCa = (invoice) => {
    const updatedVendors = [...(invoice.vendorIds || [])];
    if (user?.caId && !updatedVendors.includes(user.caId)) {
      updatedVendors.push(user.caId);
    }

    const data = JSON.stringify({
      sendToCa: true,
      vendorIds: updatedVendors
    });
    const config = {
      method: 'patch',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_HOST}proposal/${invoice._id}`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userToken}`
      },
      data: data
    };
    axios.request(config)
      .then((response) => {
        if (response.data.status) {
          Swal.fire({
            icon: "success",
            title: "Proposal Sent to CA Successfully",
            showConfirmButton: false,
            timer: 1500,
          });
          fetchProposals();
        }

      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "warning",
          title: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
      });

  };

  const handleAddInvoice = () => {
    navigate("/create-proposal")
  };

  const handleView = (invoiceId) => {
    const url = `/proposal/${invoiceId}/view`;
    window.open(url, '_blank');
  };

  useEffect(() => {
    fetchProposals();
  }, [fetchProposals]);

  const handleQuickFilterChange = (event) => {
    const value = event.target.value;
    const updatedFilters = { ...filters, filter: value };
    setPage(1);
    setFilters(updatedFilters);
    setActiveFilters({ ...updatedFilters });
  };

  const handleSortChange = (event) => {
    const value = event.target.value;
    const updatedFilters = { ...filters, asc: value };
    setPage(1);
    setFilters(updatedFilters);
    setActiveFilters({ ...updatedFilters });
  };

  const handleSearch = () => {
    setPage(1);
    setActiveFilters({ ...filters });
  };

  const handleResetDates = () => {
    if (!filters.fromDate && !filters.toDate) return;
    const resetFilters = { ...filters, fromDate: "", toDate: "" };
    setPage(1);
    setFilters(resetFilters);
    setActiveFilters({ ...resetFilters });
  };

  const handleLimitChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setPage(1);
    setLimit(newLimit);
  };

  const handlePageChange = (nextPage) => {
    if (nextPage < 1 || nextPage > pagination.totalPages) {
      return;
    }
    setPage(nextPage);
  };

  return (
    <div className="container-right">
      <div className="container mt-5 mt-0 d-flex flex-column">
        <div className='filter'>
          <select
            value={filters.filter}
            onChange={handleQuickFilterChange}
          >
            <option value={""}>All</option>
            <option value={'todays'}>Today's</option>
            <option value={'last3months'}>Last 3 months</option>
            <option value={'last6months'}>Last 6 months</option>
            <option value={'last12months'}>Last 12 months</option>
            <option value={'draft'}>Draft</option>
            <option value={'complete'}>Complete</option>

          </select>

          <select
            value={filters.asc}
            onChange={handleSortChange}
          >
            <option value={'yes'}>Ascending</option>
            <option value={'no'}>Descending</option>
          </select>
          <br />
          <div>
            <input
              type="date"
              placeholder="Select Start Date"
              value={filters.fromDate}
              onChange={(e) =>
                setFilters({ ...filters, fromDate: e.target.value })
              }
            />
            <input
              type="date"
              placeholder="Select End Date"
              value={filters.toDate}
              onChange={(e) =>
                setFilters({ ...filters, toDate: e.target.value })
              }
            />
            <button type='button' onClick={handleSearch} disabled={isLoading}>
              Search
            </button>
            <button
              type='button'
              onClick={handleResetDates}
              disabled={isLoading || (!filters.fromDate && !filters.toDate)}
            >
              Reset
            </button>
          </div>
        </div>
      <div className="d-flex justify-content-end">
      
       
        <button className="btn btn-dark new" onClick={handleAddInvoice}>
          + New
        </button>
      </div>

      {error && (
        <div className="alert alert-danger mt-3" role="alert">
          {error}
        </div>
      )}
     
      <table className="table table-striped">
        {/* Table headers */}
        <thead>
          <tr>
          <th scope="col">
          <input type="checkbox"/>
          </th>
            <th scope="col">Date</th>
            <th scope="col">Proposal#</th>
            <th scope="col">Organisation Name</th>
            <th scope="col">Status</th>
            <th scope="col">Amount</th>
            <th scope="col">Manage</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="7" className="text-center py-4">
                Loading proposals...
              </td>
            </tr>
          ) : proposals.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center py-4">
                No proposals found.
              </td>
            </tr>
          ) : (
            proposals.map((proposal, index) => (
              <tr
                key={proposal._id}
                className={index % 2 === 0 ? "bg-light" : "bg-secondary text-black"}
              >
                <td><input type="checkbox" /></td>
                <td>
                  {proposal.createdDate
                    ? moment(proposal.createdDate).format('DD-MM-YYYY')
                    : "-"}
                </td>
                <td>
                  <InvoiceNumberComponent page={'QT'} billNumber={proposal.billNumber} createdDate={proposal.createdDate} />
                </td>
                <td>{proposal.orgName || "-"}</td>
                <td>{proposal.proposalStatus || "-"}</td>
                <td>₹ {Number(proposal.totalINR || 0).toFixed(2)}</td>
                <td>
                  <DropdownButton
                    id={`proposal-actions-${proposal._id}`}
                    variant='dark'
                    title={<BsThreeDots size={26} />}
                  >
                    <button
                      type='button'
                      onClick={() => handleView(proposal._id)}
                      className="btn btn-secondary mb-2"
                    >
                      <FaCloudDownloadAlt size={26} color="white" />
                    </button>
                    <Dropdown.Item as="button" onClick={() => handleView(proposal._id)}>View</Dropdown.Item>
                    <Dropdown.Item as="button" onClick={() => navigate(`/proposal/edit/${proposal._id}`)} >Edit</Dropdown.Item>
                    <Dropdown.Item as="button" onClick={() => navigate(`/create-invoice/${proposal._id}`)}>Convert To Invoice</Dropdown.Item>
                    <Dropdown.Item as="button" onClick={() => handleDelete(proposal._id)}>Delete</Dropdown.Item>
                    <Dropdown.Item
                      as="button"
                      onClick={() => handleSendToCa(proposal)}
                      disabled={proposal.proposalStatus !== 'complete'}
                    >
                      {proposal.sendToCa ? "Sent to CA" : "Send to CA"}
                    </Dropdown.Item>
                </DropdownButton>
                </td>
              </tr>
            ))
          )}


        </tbody>
      </table>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 gap-2">
        <div>
          Showing {isLoading ? 0 : proposals.length} of {pagination.total} proposals
        </div>
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-outline-secondary"
            onClick={() => handlePageChange(page - 1)}
            disabled={isLoading || page <= 1}
          >
            Previous
          </button>
          <span>
            Page {page} of {pagination.totalPages}
          </span>
          <button
            className="btn btn-outline-secondary"
            onClick={() => handlePageChange(page + 1)}
            disabled={isLoading || page >= pagination.totalPages}
          >
            Next
          </button>
          <select
            className="form-select"
            value={limit}
            onChange={handleLimitChange}
            disabled={isLoading}
            style={{ width: "auto" }}
          >
            <option value={10}>10 / page</option>
            <option value={25}>25 / page</option>
            <option value={50}>50 / page</option>
          </select>
        </div>
      </div>
    </div>
    
    </div>
  );
};

export default ProposalList;

